exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".icon-list{list-style-type:none;display:flex;padding:0}.icon-list span{margin-right:1em}.icon-list .e-icon{width:3rem;height:3rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5999d310","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/js/page/template.vue
// module id = 40
// module chunks = 0